import { Button, Popover } from "antd";
import { TooltipPlacement } from "antd/es/tooltip";
import cn from "classnames";
import { ReactNode, useEffect, useRef, useState } from "react";
import styles from "./index.module.scss";

export type MinerDataPopoverType3 = "ADDR" | "IP" | "MAC" | "PASS";

export interface MinerDataPopover3Props {
  readonly className?: string;
  readonly iconSrc: string;
  readonly loader?: MinerDataPopoverType3 | "ALL";
  readonly showCopy: boolean;
  readonly disabledIp: boolean;
  readonly disabledMac: boolean;
  readonly disabledPass: boolean;
  readonly reproxyContent?: ReactNode;
  readonly closeDelayMs?: number;
  readonly placement?: TooltipPlacement;
  onOpenChange(open: boolean): void;
  onCopyData(type: MinerDataPopoverType3): void;
}

export default function MinerDataPopover3(props: MinerDataPopover3Props) {
  const [open, setOpen] = useState(false);
  const openRef = useRef(false);
  const closeTimer = useRef<number>();
  const closeDelayMs = props.closeDelayMs ?? 250;

  const clearCloseTimer = () => {
    if (closeTimer.current === undefined) return;
    window.clearTimeout(closeTimer.current);
    closeTimer.current = undefined;
  };

  const setPopoverOpen = (nextOpen: boolean) => {
    if (openRef.current === nextOpen) return;
    openRef.current = nextOpen;
    setOpen(nextOpen);
    props.onOpenChange(nextOpen);
  };

  const openPopover = () => {
    clearCloseTimer();
    setPopoverOpen(true);
  };

  const scheduleClose = () => {
    clearCloseTimer();
    closeTimer.current = window.setTimeout(() => {
      closeTimer.current = undefined;
      setPopoverOpen(false);
    }, closeDelayMs);
  };

  useEffect(() => clearCloseTimer, []);

  const content = (
    <div
      className={styles.content}
      onMouseEnter={openPopover}
      onMouseLeave={scheduleClose}
    >
      <Button
        size="small"
        className={styles.btn}
        onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
          props.onCopyData("IP");
        }}
        loading={props.loader === "IP" || props.loader === "ALL"}
        disabled={props.disabledIp}
      >
        IP
      </Button>
      <Button
        size="small"
        className={styles.btn}
        onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
          props.onCopyData("MAC");
        }}
        loading={props.loader === "MAC" || props.loader === "ALL"}
        disabled={props.disabledMac}
      >
        MAC
      </Button>
      <Button
        size="small"
        className={styles.btn}
        onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
          props.onCopyData("PASS");
        }}
        loading={props.loader === "PASS" || props.loader === "ALL"}
        disabled={props.disabledPass}
      >
        Pass
      </Button>
      {props.reproxyContent}
    </div>
  );

  return (
    <Popover
      open={open}
      placement={props.placement ?? "right"}
      color="#fff"
      content={content}
      trigger={[]}
    >
      <button
        type="button"
        aria-label="Скопировать данные майнера"
        className={cn(styles.copyButton, props.className)}
        onMouseEnter={openPopover}
        onMouseLeave={scheduleClose}
        onFocus={openPopover}
        onBlur={scheduleClose}
        onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
          props.onCopyData("ADDR");
        }}
      >
        <img src={props.iconSrc} alt="" loading="lazy" />
      </button>
    </Popover>
  );
}
